import InputAdornment from '@mui/material/InputAdornment'
import Typography from '@mui/material/Typography'
import { UInput } from './UInput.component'

export interface PhoneInputProps {
    label?: string
    value: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    dialCode?: string
    disabled?: boolean
    error?: boolean
    helperText?: string
    required?: boolean
    inputTestId?: string
}

export const PhoneInput = ({ label = 'Phone', value, onChange, dialCode, disabled, error, helperText, required, inputTestId }: PhoneInputProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const digitsOnly = event.target.value.replace(/\D/g, '')
        if (digitsOnly === event.target.value) {
            onChange(event)
            return
        }

        const sanitizedEvent = {
            ...event,
            target: {
                ...event.target,
                value: digitsOnly
            },
            currentTarget: {
                ...event.currentTarget,
                value: digitsOnly
            }
        } as React.ChangeEvent<HTMLInputElement>
        onChange(sanitizedEvent)
    }

    return (
        <UInput
            label={label}
            value={value}
            onChange={handleChange}
            fullWidth
            required={required}
            error={error}
            helperText={helperText}
            disabled={disabled}
            autoComplete="off"
            slotProps={{
                htmlInput: {
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    autoComplete: 'off',
                    ...(inputTestId ? { 'data-testid': inputTestId } : {})
                },
                input: dialCode
                    ? {
                          startAdornment: (
                              <InputAdornment position="start" sx={{ mr: '5px' }} data-testid="phone-input-input-adornment">
                                  <Typography
                                      variant="body2"
                                      component="span"
                                      sx={{ fontSize: 14, fontWeight: 400, color: '#86868B' }}
                                      data-testid="phone-input-typography">
                                      {dialCode} {'(0)'}
                                  </Typography>
                              </InputAdornment>
                          )
                      }
                    : undefined
            }}
            sx={
                dialCode
                    ? {
                          '& .MuiInputBase-input': { paddingLeft: 0 },
                          '& .MuiInputAdornment-root .MuiTypography-root': { color: '#86868B !important' }
                      }
                    : undefined
            }
            data-testid="phone-input-uinput-on-change"
        />
    )
}
